import { IDENTITYKEY } from '@/store/User';

export function getUserTitle(type: IDENTITYKEY) {
  switch (type) {
    case 'freeVip':
      return 'merror.sub.free';
    case 'basicVip':
      return 'merror.sub.standard';
    case 'advancedVip':
      return 'merror.sub.pro';
    case 'enterpriseVip':
      return 'merror.sub.enterprise';
    default:
      return '-';
  }
}
